import { tagged as tagged2 } from "@silversea-ssc/functional-support";
import { summon } from "@silversea-ssc/functional-support";
var AmountPerBookingCancellationPenalty = /* @__PURE__ */ summon((F) => F.interface({
  type: F.stringLiteral("fixedAmountPerBooking"),
  amount: F.number()
}, "AmountPerBookingCancellationPenalty"));
import { summon as summon2 } from "@silversea-ssc/functional-support";
var AmountPerPersonCancellationPenalty = /* @__PURE__ */ summon2((F) => F.interface({
  type: F.stringLiteral("fixedAmountPerPerson"),
  amount: F.number()
}, "AmountPerPersonCancellationPenalty"));
import { tagged } from "@silversea-ssc/functional-support";
import { summon as summon3 } from "@silversea-ssc/functional-support";
var PercentageCancellationPenalty = /* @__PURE__ */ summon3((F) => F.interface({
  type: F.stringLiteral("percentage"),
  percentage: F.number()
}, "PercentageCancellationPenalty"));
import { summon as summon4 } from "@silversea-ssc/functional-support";
var PercentageCancellationPenaltyWithMaxAmount = /* @__PURE__ */ summon4((F) => F.interface({
  type: F.stringLiteral("percentageWithMaximumAmount"),
  percentage: F.number(),
  maxAmount: F.number()
}, "PercentageCancellationPenaltyWithMaxAmount"));
var CancellationPenalty = /* @__PURE__ */ tagged("type")({
  fixedAmountPerPerson: AmountPerPersonCancellationPenalty,
  fixedAmountPerBooking: AmountPerBookingCancellationPenalty,
  percentage: PercentageCancellationPenalty,
  percentageWithMaximumAmount: PercentageCancellationPenaltyWithMaxAmount
});
var AdministrativeFee = /* @__PURE__ */ tagged2("type")({
  fixedAmountPerPerson: AmountPerPersonCancellationPenalty,
  fixedAmountPerBooking: AmountPerBookingCancellationPenalty
});
import { summon as summon5 } from "@silversea-ssc/functional-support";
var CancellationPeriod = /* @__PURE__ */ summon5((F) => F.interface({
  validUntilDaysBeforeDeparture: F.number(),
  penalty: CancellationPenalty(F)
}, "CancellationPeriod"));
import { summon as summon9 } from "@silversea-ssc/functional-support";
import { FareCode } from "@silversea-ssc/web-fares-fp";
import { summon as summon6 } from "@silversea-ssc/functional-support";
var Refundability = /* @__PURE__ */ summon6((F) => F.keysOf({
  refundable: null,
  nonRefundable: null,
  exchangeableForCredit: null
}));
import { summon as summon8 } from "@silversea-ssc/functional-support";
import { summon as summon7 } from "@silversea-ssc/functional-support";
var CurrencyCode = /* @__PURE__ */ summon7((F) => F.keysOf({
  USD: null,
  EUR: null,
  AUD: null,
  GBP: null,
  CAD: null
}));
var SingleCurrencySpecificCruisePaymentTerms = /* @__PURE__ */ summon8((F) => F.interface({
  cancellationPeriods: F.nullable(F.array(CancellationPeriod(F))),
  cancellationAdminFee: F.nullable(AdministrativeFee(F))
}, "SingleCurrencySpecificCruisePaymentTerms"));
var CurrencySpecificCruisePaymentTerms = /* @__PURE__ */ summon8((F) => F.record(CurrencyCode(F), SingleCurrencySpecificCruisePaymentTerms(F)));
var CruisePaymentTerms = /* @__PURE__ */ summon9((F) => F.interface({
  _id: F.string(),
  cruiseCode: F.string(),
  country: F.string(),
  fareCode: FareCode(F),
  currencies: CurrencySpecificCruisePaymentTerms(F),
  type: Refundability(F),
  seedVersion: F.string(),
  depositInPercent: F.number()
}, "CruisePaymentTerms"));
export {
  AdministrativeFee,
  AmountPerBookingCancellationPenalty,
  AmountPerPersonCancellationPenalty,
  CancellationPenalty,
  CancellationPeriod,
  CruisePaymentTerms,
  CurrencyCode,
  CurrencySpecificCruisePaymentTerms,
  PercentageCancellationPenalty,
  PercentageCancellationPenaltyWithMaxAmount,
  Refundability,
  SingleCurrencySpecificCruisePaymentTerms
};
